<template>
  <div class="forwardingReport" ref="body">
    <div class="hierarchy">
      <!-- <div class="dataTitle">
        <van-icon class="hospiyalsArrowLeft" style="top: 16px;" name="arrow-left" @click="onBack" />
        <div class="title">
          <div class="content" @click="toReport" v-if="examReport">检查报告</div>
          <div class="line" v-if="examReport">|</div>
          <div class="content" @click="toPortrait">数字影像</div>
          <div class="line">|</div>
          <div class="content action">转发报告</div>
        </div>
      </div>-->
      <div v-if="report">
        <div class="effectiveTime">
          <div class="forwardingVanDropdown">
            <van-cell class="effectiveVancell" title="有效时长" />
            <van-dropdown-menu class="effectiveVanDropdow">
              <van-dropdown-item v-model="value" :options="option1" @change="getMakeReportLink" />
            </van-dropdown-menu>
          </div>
        </div>
        <div class="effectiveContent">
          <div class="effectivePc">
            <div class="contentTitle">
              <div class="label"></div>
              <div class="value">转发电脑端用户方法</div>
              <div class="label"></div>
            </div>
            <div class="forwardingPC">
              <div>
                电脑浏览器输入网址
                <div id="copy-txt">{{forwardingData.url}}</div>
              </div>
              <!-- <div>对方输入访问密码,即可查看报告。</div> -->
              <van-checkbox-group v-model="result" @change="eventChange">
                <van-checkbox name="a" shape="square">加密（输入访问密码可以查看报告）</van-checkbox>
                <van-checkbox name="b" shape="square">匿名化</van-checkbox>
              </van-checkbox-group>
              <van-button class="copyButton"  size="mini" @click="toCopy">复制</van-button>
            </div>
          </div>
          <div class="effectiveMobile">
            <div class="contentTitle">
              <div class="label"></div>
              <div class="value">转发手机端用户方法</div>
              <div class="label"></div>
            </div>
            <div class="forwardingMobile">
              <div>点击发送给好友，对方输入访问密码</div>
              <div>即可查阅您的报告。</div>
            </div>
          </div>
          <button class="sendButton" @click="wxSDK">发送给好友</button>
        </div>
        <div class="forwardingFooter">
          <div class="password">访问密码：{{forwardingData.code}}</div>
          <!-- <div class="operationPrompt">温馨提示:转发报告会自动进行脱敏处理</div> -->
        </div>
      </div>
      <div v-if="noreport" class="white_title">暂无报告</div>
    </div>
    <div class="montmorillonite" @click="Montmorillonite" v-if="montmorillonite">
      <img class="arrowDirection" src="../../../../assets/guide.png" alt />
      <div class="forwardPrompt">
        点击右上角
        <img src="../../../../assets/threePoints.png" alt />
      </div>
      <div class="forwardPromptTwo">将它转发给指定的朋友</div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import axios from "axios";
import Storage from "@/tools/storage";
import { getPatientInfo, makeOutLink } from "@/api/reportOuter";
import { makeReportLink, getReportInfo } from "@/api/report";
import { getGcPatientInfo } from "@/api/reportQuery";
import Vue from "vue";
import { Notify } from "vant";
import { link } from "fs";
export default {
  name: "forwardingReport",
  data() {
    return {
      examReport: true,
      montmorillonite: false,
      forwardingData: {},
      value: 3,
      option1: [
        { text: "1天", value: 1 },
        { text: "3天", value: 3 },
        { text: "7天", value: 7 }
      ],
      login: "../../../../../assets/login.png",
      report: true,
      noreport: false,
      message: " \n 本服务由公众号：数字影像云提供",
      result: [],
      isAnonymous: 0,
      isEncrypt: 0
    };
  },
  methods: {
    /* 判断是否可以转发 */
    initial() {
      getGcPatientInfo({
        exam_id: JSON.parse(Storage.get("reportInfo"))[0].exam_id
      }).then(res => {
        if (res.length) {
          if (res[0].exam_status == 9 || res[0].report_status == 9) {
            this.report = true;
            this.noreport = false;
          }
        } else {
          this.report = false;
          this.noreport = true;
        }
      });
    },
    onBack() {
      // this.$router.push({ path: '/filmQuery' })
      this.$router.go(-1);
    },
    toReport() {
      this.$router.push({ path: "/reportInfoOuter/report" });
    },
    toPortrait() {
      this.$router.push({ path: "/reportInfoOuter/portrait" });
    },
    Montmorillonite() {
      this.montmorillonite = false;
    },
    eventChange(e) {
      console.log(e)
      // a 加密 b 匿名
      if(e.length === 2){
        this.isAnonymous = 1
        this.isEncrypt = 1
      }else if(e.length === 0){
        this.isAnonymous = 0
        this.isEncrypt = 0
      }else if(e.length === 1 && e.indexOf('a') != -1){
        this.isAnonymous = 0
        this.isEncrypt = 1
      }else if(e.length === 1 && e.indexOf('b') != -1){
        this.isAnonymous = 1
        this.isEncrypt = 0
      }
    },
    anonymizeNameInUrl(url, anonymizedPart = '**') {  
      const nameParamRegex = /&?name=([^&]*)/;  
      const match = url.match(nameParamRegex);  
      if (match) {  
        const originalName = decodeURIComponent(match[1]);  
        const anonymizedName = originalName.charAt(0) + anonymizedPart;  
        const anonymizedUrl = url.replace(nameParamRegex, `&name=${encodeURIComponent(anonymizedName)}`);  
        // return anonymizedUrl.replace('&name=', 'name=');  
        return anonymizedUrl
      }  
      return url;   
    },
    toCopy() {
      let Url2 = encodeURI(this.forwardingData.url);
      let oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = this.getUrl(Url2)
      // oInput.value = Url2 + "密码：" + this.forwardingData.code; //赋值
      this.$refs.body.appendChild(oInput);
      // document.body.appendChild(oInput)
      oInput.select(); // 选择对象
      let judge = document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      if (judge == true) {
        Notify({ type: "success", message: "复制成功,请选择联系人去粘贴吧" });
      } else {
        alert("复制失败，请您手动复制");
      }
    },
    getUrl(Url2){
      if(this.isAnonymous && this.isEncrypt){
        return this.anonymizeNameInUrl(Url2) + '&isAnonymous=' + this.isAnonymous + '&isEncrypt=' + this.isEncrypt + ' ' + '密码：' + this.forwardingData.code //赋值
      }else if(!this.isAnonymous && !this.isEncrypt){
        return Url2 + '&isAnonymous=' + this.isAnonymous + '&isEncrypt=' + this.isEncrypt + ' '//赋值
      }else if(this.isAnonymous && !this.isEncrypt){
        return this.anonymizeNameInUrl(Url2) + '&isAnonymous=' + this.isAnonymous + '&isEncrypt=' + this.isEncrypt + ' '
      }else if(!this.isAnonymous && this.isEncrypt){
        return Url2 + '&isAnonymous=' + this.isAnonymous + '&isEncrypt=' + this.isEncrypt + ' ' + '密码：' + this.forwardingData.code //赋值
      }
    },
    wxSDK() {
      let url = window.location.href
      const firstPart = url.substring(0, url.indexOf('.'));
      this.montmorillonite = true;
      this.toCopy();
      let Url2 = encodeURI(this.forwardingData.url);
      let urlParams = new URLSearchParams(Url2.split('?')[1]);
      let isDcm = urlParams.get('is_dcm');
      const that = this;
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          const appId = res.data.appId;
          const timestamp = res.data.timestamp;
          const nonceStr = res.data.nonceStr;
          const signature = res.data.signature;
          // 利用重定向解决ios vue hash模式下微信分享后打开首页而不是当前分享页面问题
          let shareLink =
          firstPart+".pacsonline.cn/#/reportInfoOuter?id=" +
            that.forwardingData.id +
            "&short=1&is_dcm="+ isDcm + "&name=" +
            JSON.parse(Storage.get("reportInfo"))[0].name
          shareLink =
            window.location.href.split("#")[0] +
            "redirect.html?shareRedirect=" +
            encodeURIComponent(this.getUrl(shareLink));
          let imgUrl = firstPart+".pacsonline.cn/share.png";
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: [
              "onMenuShareTimeline", // 分享到朋友圈
              "onMenuShareAppMessage", // 分享到微信好友
              "onMenuShareQQ", // 分享到QQ
              "onMenuShareWeibo", // 分享到微博
              "onMenuShareQZone", // 分享到空间
              "hideMenuItems", // 批量隐藏菜单
              "scanQRCode"
            ]
          });
          // updateAppMessageShareData
          wx.ready(function() {
            wx.onMenuShareAppMessage({
              title:
                JSON.parse(Storage.get("reportInfo"))[0].name + "的检查报告", // 分享描述
              desc: "密码:" + that.forwardingData.code + that.message,
              link: shareLink,
              imgUrl: imgUrl, // 分享图标
              type: "link", // 分享类型,music、video或link，不填默认为link
              dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
              success: function(res) {
                alert("成功了");
                that.montmorillonite = false;
                // 用户点击了分享后执行的回调函数
              },
              cancel: function() {
                alert("取消分享");
                // 用户取消分享后执行的回调函数
              }
            });
          });
          wx.error(function(res) {
            alert("进wx.error");
          });
        });
    },
    async getMakeReportLink() {
      let params;
      if (Storage.get("code") == 2) {
        params = {
          url: "https://wc4.pacsonline.cn/#/reportInfoOuter",
          overdueTime: this.value,
          examId: JSON.parse(Storage.get("reportInfo"))[0].exam_id,
          phone: "",
          report: 2,
          study_id: JSON.parse(Storage.get("reportInfo"))[0].study_id
        };
      } else {
        params = {
          url: "https://wc4.pacsonline.cn/#/reportInfoOuter",
          overdueTime: this.value,
          examId: JSON.parse(Storage.get("reportInfo"))[0].exam_id,
          // examId: "116bf91c68748f9b",
          phone: "",
          report: 1,
          study_id: JSON.parse(Storage.get("reportInfo"))[0].study_id
          // study_id: "116bf91c68556a69"
        };
      }
      let res = await makeOutLink(params);
      if (res) {
        this.forwardingData = res;
      }
    }
  },
  mounted() {
    this.initial();
    this.getMakeReportLink();
  },
  created() {
    if (Storage.get("code") == 2 && Storage.get("examStatus") == 1) {
      this.examReport = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../style/reportInfo/index.css";
@import "../../../../style/reportInfo/forwarding.css";
.van-cell__title {
  padding-left: 0;
}
.forwardingReport {
  text-align: center;
}
.white_title {
  height: 100vh;
  line-height: 100vh;
  font-size: 20px;
}
</style>


